export const CURRENCY_SYMBOLS = { USD: "$", INR: "₹", EUR: "€", GBP: "£" };

export function fmtCurrency(amount, currency = "USD") {
    const num = typeof amount === "string" ? parseFloat(amount) : amount;
    if (Number.isNaN(num) || num === null || num === undefined) return `${CURRENCY_SYMBOLS[currency] || ""}0.00`;
    const sign = num < 0 ? "-" : "";
    const abs = Math.abs(num);
    return `${sign}${CURRENCY_SYMBOLS[currency] || ""}${abs.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fmtCompact(amount, currency = "USD") {
    const num = typeof amount === "string" ? parseFloat(amount) : amount;
    if (Number.isNaN(num) || num === null || num === undefined) return `${CURRENCY_SYMBOLS[currency] || ""}0`;
    const sign = num < 0 ? "-" : "";
    const abs = Math.abs(num);
    if (abs >= 1_000_000) return `${sign}${CURRENCY_SYMBOLS[currency] || ""}${(abs/1_000_000).toFixed(1)}M`;
    if (abs >= 1_000) return `${sign}${CURRENCY_SYMBOLS[currency] || ""}${(abs/1_000).toFixed(1)}k`;
    return `${sign}${CURRENCY_SYMBOLS[currency] || ""}${abs.toFixed(0)}`;
}

export function fmtDate(dateStr, opts = {}) {
    if (!dateStr) return "";
    // Parse only the YYYY-MM-DD portion as local midnight to avoid UTC-to-local
    // timezone shift that would show the wrong day (e.g., May 15 UTC → May 14 in UTC-5).
    const [year, month, day] = dateStr.slice(0, 10).split("-").map(Number);
    const d = new Date(year, month - 1, day);
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric", ...opts });
}

export function fmtRelative(dateStr) {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return "just now";
    if (diff < 3600) return `${Math.floor(diff/60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff/3600)}h ago`;
    if (diff < 604800) return `${Math.floor(diff/86400)}d ago`;
    return fmtDate(dateStr);
}

export function daysUntil(dateStr) {
    if (!dateStr) return null;
    const [year, month, day] = dateStr.slice(0, 10).split("-").map(Number);
    const d = new Date(year, month - 1, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return Math.ceil((d.getTime() - today.getTime()) / 86400000);
}

export const CATEGORY_COLORS = {
    Groceries: "#10B981",
    Transport: "#0EA5E9",
    "Food & Drink": "#F59E0B",
    Utilities: "#6366F1",
    Shopping: "#EC4899",
    Entertainment: "#8B5CF6",
    Health: "#EF4444",
    Education: "#14B8A6",
    Salary: "#10B981",
    Freelance: "#22D3EE",
    Other: "#94A3B8",
};

export const EXPENSE_CATEGORIES = [
    "Groceries","Transport","Food & Drink","Utilities","Shopping",
    "Entertainment","Health","Education","Travel","Rent","Other"
];

export const INCOME_CATEGORIES = ["Salary","Freelance","Investment","Gift","Refund","Other"];

export const SUB_CATEGORIES = [
    "Entertainment","Productivity","Storage","News","Music","Shopping","Health","Education","Other"
];

export const PAYMENT_METHODS = ["Cash","Credit Card","Debit Card","Bank Transfer","PayPal","Apple Pay","Google Pay","Other"];

export const BILLING_CYCLES = [
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
    { value: "quarterly", label: "Quarterly" },
    { value: "yearly", label: "Yearly" },
];

export function monthlyCostOf(cost, cycle) {
    const c = parseFloat(cost) || 0;
    if (cycle === "weekly") return c * 4.345;
    if (cycle === "monthly") return c;
    if (cycle === "quarterly") return c / 3;
    if (cycle === "yearly") return c / 12;
    return c;
}
